if (!customElements.get("tabbed-products")) {
  class TabbedProducts extends HTMLElement {
    constructor() {
      super();

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.container = this.querySelector(".tabbed-products__slider-inner");

      /** @type {NodeListOf<HTMLElement>} */
      this.slides = this.querySelectorAll(".tabbed-products__slide");

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.prevButton = this.querySelector(
        ".tabbed-products__nav-btn[data-prev]",
      );

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.nextButton = this.querySelector(
        ".tabbed-products__nav-btn[data-next]",
      );

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.mobilePrevButton = this.querySelector(
        ".tabbed-products__mobile-nav-btn[data-prev]",
      );

      /** @type {HTMLElement} */
      // @ts-expect-error
      this.mobileNextButton = this.querySelector(
        ".tabbed-products__mobile-nav-btn[data-next]",
      );

      /** @type {NodeListOf<HTMLButtonElement>} */
      this.pillButtons = this.querySelectorAll(".tabbed-products__pill-btn");

      this.prevButton.addEventListener("click", this.onPrev.bind(this));
      this.nextButton.addEventListener("click", this.onNext.bind(this));
      this.mobilePrevButton.addEventListener("click", this.onPrev.bind(this));
      this.mobileNextButton.addEventListener("click", this.onNext.bind(this));
      this.container.addEventListener("scrollend", this.onScrollEnd.bind(this));

      this.pillButtons.forEach((pill) => {
        pill.addEventListener("click", this.onTabClick.bind(this));
      });
    }

    getCurrentSlideIndex() {
      const scrollLeft = this.container.scrollLeft;
      let index = 0;
      for (const slide of this.slides) {
        if (slide.offsetLeft >= scrollLeft) {
          break;
        }
        index++;
      }

      return index;
    }

    onScrollEnd() {
      const index = this.getCurrentSlideIndex();
      this.setIndex(index);
    }

    /**
     * @param {Event} event
     */
    onTabClick(event) {
      const handle = event.target.dataset.collectionHandle;
      let index = 0;
      let found = true;

      for (const slide of this.slides) {
        if (slide.dataset.collectionHandle === handle) {
          found = true;
          break;
        }
        index++;
      }

      if (found) {
        this.setIndex(index);
      }
    }

    /**
     * @param {Event} event
     */
    onPrev(event) {
      const step = parseInt(event.currentTarget.dataset.prev);
      const current = this.getCurrentSlideIndex();
      const prev = current === 0 ? this.slides.length - step : current - step;
      this.setIndex(prev);
    }

    /**
     * @param {Event} event
     */
    onNext(event) {
      const step = parseInt(event.currentTarget.dataset.next);
      const current = this.getCurrentSlideIndex();
      const next = current + step >= this.slides.length ? 0 : current + step;
      this.setIndex(next);
    }

    /**
     * @param {string} collectionHandle
     * @param {boolean} scrollToIndex
     */
    setActiveTab(collectionHandle, scrollToIndex) {
      const pills = this.querySelectorAll(".tabbed-products__pill-btn");
      for (const pill of pills) {
        if (pill.dataset.collectionHandle === collectionHandle) {
          pill.classList.add("is-active");
        } else {
          pill.classList.remove("is-active");
        }
      }
    }

    /**
     * @param {number} index
     */
    setIndex(index) {
      const currentIndex = this.getCurrentSlideIndex();
      const needsScroll = currentIndex !== index;
      const currentSlide = this.slides[index];
      const currentCollection = currentSlide.dataset.collectionHandle;

      if (needsScroll) {
        this.container.scrollLeft = this.slides[index].offsetLeft;
      }

      this.setActiveTab(currentCollection, false);
    }
  }

  customElements.define("tabbed-products", TabbedProducts);
}
